import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import togglable from './togglable.js'
import toggler from './toggler.js'

export default contract({
  toggler: array([
    toggler
  ]),
  togglable: array([
    togglable
  ])
})
